import NormTreeTable from './components/NormTreeTable';

export default [
  {
    key: 'show',
    component: NormTreeTable,
    path: '/norms/:type?',
    public: false,
    canReloadOnLinkClick: true,
  },
];